<template>
    <b-modal :no-close-on-backdrop="true" :title="$t('item_add_new')" ref="innermodal">
        <div class="row">
            <div class="col-sm-12 col-md-12 col-lg-12">
                <div class="item-img-element">
                    <div class="side-left">
                        <div class="card-img-top">
                            <img :src="img" @click="$refs.file.click()" />
                            <input type="file" ref="file" hidden accept="image/*" @change="fileChange"/>
                        </div>
                    </div>
                    <div class="side-right">
                        <div class="form-group">
                            <label class="blue">{{$t('item_name')}}
                                <span class="text-danger">*</span>
                            </label>
                            <div>
                                <input type="text" class="form-control form-control-sm" v-model="model.Name"/>
                            </div>
                        </div>
                        <div class="form-group" style="margin-bottom: 0;">
                            <label><input type="checkbox" v-model="model.CanSold"> {{$t('can_be_sold')}}</label>
                        </div>
                        <div class="form-group">
                            <label><input type="checkbox" v-model="model.CanPurchase"> {{$t('can_be_purchase')}}</label>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-12 col-md-6 col-lg-6">
                        <div class="form-group">
                            <label class="blue">{{ $t('barcode') }}<span class="text-danger">*</span></label>
                            <div>
                                <input class="form-control form-control-sm" type="text" v-model="model.Num">
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-12 col-md-6 col-lg-6">
                        <div class="form-group">
                            <label class="blue">{{ $t('serialno') }}</label>
                            <div>
                                <input class="form-control form-control-sm" type="text" v-model="model.SerialNum">
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-12 col-md-6 col-lg-6">
                        <div class="form-group">
                            <label class="blue">{{ $t('itemtype') }}</label>
                            <div>
                                <select class="form-control form-control-sm" v-model="model.ProductTypeId">
                                    <option value="1">ទំនិញ</option>
                                    <option value="2">សេវាកម្ម</option>
                                </select>
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-12 col-md-6 col-lg-6">
                        <div class="form-group">
                            <label class="blue">{{ $t('item_category_name') }}</label>
                            <div>
                                <select class="form-control form-control-sm" v-model="model.CategoryId">
                                    <option value=""></option>
                                    <option v-for="ret in categories" :value="ret.Id" :key="ret.Id">{{ret.Name}}</option>
                                </select>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-12 col-md-6 col-lg-6">
                        <div class="form-group">
                            <label class="blue">{{ $t('uom') }}</label>
                            <div>
                                <select class="form-control form-control-sm" v-model="model.UomId">
                                    <option v-for="ret in units" :value="ret.Id" :key="ret.Id">{{ret.Name}}</option>
                                </select>
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-12 col-md-6 col-lg-6">
                        <div class="form-group">
                            <label class="blue">{{ $t('model') }}</label>
                            <div>
                                <select class="form-control form-control-sm" v-model="model.BrandId">
                                    <option value=""></option>
                                    <option v-for="ret in brands" :value="ret.Id" :key="ret.Id">{{ret.Name}}</option>
                                </select>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-6">
                        <div class="form-group">
                            <label class="blue">{{ $t('price_sale') }}</label>
                            <div>
                                <input class="form-control form-control-sm" type="number" v-model="model.Price">
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-6">
                        <div class="form-group">
                            <label class="blue">{{ $t('cost') }}</label>
                            <div>
                                <input class="form-control form-control-sm" type="number" v-model="model.Cost">
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-6">
                        <div class="form-group">
                            <label class="blue">{{ $t('qty_begin') }}</label>
                            <div>
                                <input class="form-control form-control-sm" type="number" v-model="model.BeginQty">
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-6">
                        <div class="form-group">
                            <label class="blue">{{ $t('qty_alert') }}</label>
                            <div>
                                <input class="form-control form-control-sm" type="number" v-model="model.AlertQty">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <template v-slot:modal-footer>
            <button type="button" class="btn btn-danger btn-sm" @click="$refs.innermodal.hide()"><i class="fa fa-times" aria-hidden="true"></i> {{$t('close')}}</button>
            <button type="button" class="btn btn-success btn-sm" @click="clickSaveHandler"><i class="fa fa-floppy-o" aria-hidden="true"></i> {{$t('save')}}</button>
        </template>
    </b-modal>
</template>
<script>
export default {
    data() {
        return {
            model: {
                Id: null,
                Num: '',
                Name: '',
                Description: '',
                ProductTypeId: '1',
                CategoryId: '',
                CanSold: true,
                CanPurchase: true,
                Image: '',
                BeginCost: 0,
                Cost: 0,
                Price: 0,
                AlertQty: 0,
                BeginQty: 0,
                UomId: '00000000-0000-0000-0000-000000000000',
                BrandId: '00000000-0000-0000-0000-000000000000'
            },
            categories: [],
            units: [],
            brands: [],
            img: '/img/avatars/1.jpg',
            actionLink: 'item/save',
            formHead: {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            }
        }
    },
    created: function() {
        this.getCategory();
        this.getUnit();
        this.getBrand();
    },
    methods: {
        getCategory() {
            this.$api().post('category').then(res => {
                if (this.$isValid(res)) {
                    this.categories = res.data.Data;
                    if (this.categories.length > 0) {
                        this.model.CategoryId = this.categories[0].Id;
                    }
                }
            });
        },
        getUnit(){
            this.$api().post('uom', {}).then(res => {
                if (this.$isValid(res)) {
                    this.units = res.data.Data;
                }
            });
        },
        getBrand(){
            this.$api().post('brands').then(res => {
                if (this.$isValid(res)) {
                    this.brands = res.data.Data;
                }
            });
        },
        clickSaveHandler() {
            let loading = this.$loading.show();
            let formData = new FormData();
            formData.append('File', this.$refs.file.files[0]);
            for(let p in this.model){
                if(this.model[p] != null)
                    formData.append(p, this.model[p]);
            }
            this.$api().post(this.actionLink, formData, this.formHead).then(res => {
                if(this.$isValid(res)){
                    this.$emit('success', res.data.Json.Item);
                }
            }).finally(function() { loading.hide(); });
        },
        fileChange(e) {
            this.img = URL.createObjectURL(e.target.files[0]);
        }
    }
};
</script>
<style scoped>
    .item-img-element{
        display: flex;
    }
    .item-img-element .card-img-top{
        width: 105px;
        height: 105px;
        overflow: hidden;
        border-radius: 3px;
        border: 1px solid #ddd;
    }
    .item-img-element img{
        width: 105px;
        height: 105px;
    }
    .item-img-element .side-right{
        width: 100%;
        padding-left: 10px;
    }
</style>